import React, { useState, useEffect } from "react"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

import Firebase, { Deck } from "../../../services/FirebaseService"

import style from "./DeckGrid.module.scss"

const ENTER_VARS = { opacity: 1, overwrite: false }
const LEAVE_VARS = { opacity: 0.2, overwrite: false }
const SCROLL_VARS = {
  interval: 0.05,
  batchMax: 5,
  start: "center bottom",
  end: "center top",
  onEnter: (eles: gsap.TweenTarget) => gsap.to(eles, { ...ENTER_VARS, stagger: 0.15 }),
  onEnterBack: (eles: gsap.TweenTarget) => gsap.to(eles, { ...ENTER_VARS, stagger: -0.15 }),
  onLeave: (eles: gsap.TweenTarget) => gsap.to(eles, LEAVE_VARS),
  onLeaveBack: (eles: gsap.TweenTarget) => gsap.to(eles, LEAVE_VARS),
}

type DeckGridProps = {}

const DeckGrid: React.FC<DeckGridProps> = ({}) => {
  const [decks, setDecks] = useState<Deck[]>([])

  useEffect(() => {
    fetchDecks()
  }, [])

  useEffect(() => {
    if (!decks.length) return
    ScrollTrigger.batch(".deck", SCROLL_VARS)
  }, [decks])

  const fetchDecks = async () => {
    const decks = await Firebase.fetchDecks()
    setDecks(decks)
  }

  return (
    <div className={style.container}>
      {decks.map(deck => (
        <div key={deck.title}>
          <img src={deck.cover} alt={deck.title} className="deck" />
          <div>
            <img src={deck.logo} alt={deck.title} />
            <p className="bold center">{deck.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default DeckGrid
